import React from 'react';

const Exit = ({ width = '1.2rem', height = '1.2rem', ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 19.986 18.916"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      transform="translate(-275.145 -7657.775)"
      d="M287.927,7675.64V7674.4a.621.621,0,0,0-.234-.489l-7.231-5.857a1.092,1.092,0,0,1-.373-.817,1.066,1.066,0,0,1,.373-.817l7.231-5.857a.628.628,0,0,0,.234-.49v-1.238a1.054,1.054,0,0,0-1.7-.834l-10.694,8.4a1.1,1.1,0,0,0-.384.835,1.087,1.087,0,0,0,.384.826l10.7,8.4a1.054,1.054,0,0,0,1.7-.825Z"
    />
    <path
      transform="translate(-276.488 -7657.775)"
      d="M284.073,7666.4a1.1,1.1,0,0,0-.383.835,1.074,1.074,0,0,0,.383.826l10.7,8.4a1.054,1.054,0,0,0,1.7-.825v-16.807a1.054,1.054,0,0,0-1.7-.834Z"
    />
  </svg>
);

export default Exit;
